var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-gray-50 flex flex-col"},[_c('app-navbar'),_c('fade-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }